import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

interface AgriValuesProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    columns: string[];
    rows: string[][];
    summary: string;
  };
}

export default function AgriValues({ data }: AgriValuesProps) {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        <Reveal className="mt-12">
          <div className="overflow-x-auto rounded-2xl border border-background-200 bg-background-50">
            <table className="w-full min-w-[720px] text-left border-collapse">
              <thead>
                <tr>
                  <th className="px-5 py-4 text-sm font-semibold text-foreground-800 bg-background-100 border-b border-background-200 whitespace-nowrap w-[180px]">
                    {data.columns[0]}
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-foreground-500 bg-background-100 border-b border-background-200 whitespace-nowrap">
                    {data.columns[1]}
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-accent-900 bg-accent-100 border-b border-accent-200 whitespace-nowrap">
                    {data.columns[2]}
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((row, ri) => (
                  <tr
                    key={row[0]}
                    className={`border-b border-background-200 last:border-0 ${
                      ri % 2 === 1 ? 'bg-background-100/50' : ''
                    }`}
                  >
                    <td className="px-5 py-4 text-sm font-medium text-foreground-950 align-top whitespace-nowrap">
                      {row[0]}
                    </td>
                    <td className="px-5 py-4 text-sm text-foreground-500 align-top">
                      <span className="inline-flex items-start gap-2">
                        <i className="ri-close-line text-foreground-300 text-base mt-0.5"></i>
                        {row[1]}
                      </span>
                    </td>
                    <td className="px-5 py-4 text-sm text-foreground-800 align-top">
                      <span className="inline-flex items-start gap-2">
                        <i className="ri-check-line text-accent-600 text-base mt-0.5"></i>
                        {row[2]}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal className="mt-8" delay={100}>
          <div className="rounded-2xl bg-foreground-950 px-6 py-6 md:px-8 md:py-7 flex items-start gap-4">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-300 shrink-0">
              <i className="ri-double-quotes-l text-xl"></i>
            </span>
            <p className="text-sm md:text-base text-background-100 leading-relaxed">{data.summary}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}